<template>
  <div class="yhc-ef-kazai-detail-input--select-kazai-options-list">
    <div
      v-for="(o, index) in options"
      :key="index"
      class="yhc-ef-kazai-detail-input--select-kazai-options-list--item mt-3"
    >
      <!-- サービスごとに オプション選択Actionがある -->
      <YhcEFKazaiDetailInputSelectKazaiOptionsListItem
        :service-option="o.service"
        :kazai-type="kazaiType"
        :selected-options="selectedOptionsByServiceId[o.service.id] || []"
        @updateSelectedOptions="
          (selectedOptions) => setOptionsOfService(o.service, selectedOptions)
        "
      />
    </div>
  </div>
</template>
<script lang="ts">
import { PropType, computed, inject, toRaw } from 'vue'
import {
  ModelKazaiOptionServices,
  ModelKazaiOptionServicesOneSelection,
  ModelYhcKazaiTypesFullRelation,
} from '../../../../fireModels/yhcDataTypes'
import YhcEFKazaiDetailInputSelectKazaiOptionsListItem from './YhcEFKazaiDetailInputSelectKazaiOptionsListItem.vue'
import { originServiceNames } from '../../formUtils'

type OriginService = (typeof originServiceNames)[keyof typeof originServiceNames]

/**
 * オプションサービスs を表示するコンポーネント
 */
export default {
  components: { YhcEFKazaiDetailInputSelectKazaiOptionsListItem },
  props: {
    kazaiType: {
      type: Object as PropType<ModelYhcKazaiTypesFullRelation>,
      required: true,
    },
    selectedOptionsByServiceId: {
      type: Object as PropType<{
        [serviceId: string]: ModelKazaiOptionServicesOneSelection[]
      }>,
      required: true,
    },
    originService: {
      type: String as PropType<OriginService>,
      required: true,
    },
    isKaguidoFrom: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['selectOptions'],
  setup(props, { emit }) {
    const YhcEstimateFormFrontServiceInstance = inject(
      'YhcEstimateFormFrontServiceInstance',
    )
    const pickupAreaFlag =
      YhcEstimateFormFrontServiceInstance.$userInputData.zip_from_yhc_master
        ?.deliveryAreaFlag
    const deliveryAreaFlag =
      YhcEstimateFormFrontServiceInstance.$userInputData.zip_to_yhc_master
        ?.deliveryAreaFlag

    const options = computed(() => {
      return (
        props.kazaiType.serviceOptions
          // originServiceにprops.originServiceが含まれるものだけをフィルタリング
          .filter((o) => o.service.originService.includes(props.originService))
          .map((o) => {
            // オプションが現在のエリアで利用可能か確認
            const filteredSelections = o.service.selections.filter((selection) => {
              // ちょこっと模様替えの場合、お預かり先かお届け先かで利用可能なオプションをフィルタリングする（例えばお預かり先なのに"組み立て"オプションは不要であるため）
              if (props.originService === originServiceNames.kaguido) {
                if (props.isKaguidoFrom) {
                  return (
                    selection.areaRestrictionType === 'fromArea' ||
                    selection.areaRestrictionType === 'bothArea'
                  )
                } else {
                  return (
                    selection.areaRestrictionType === 'toArea' ||
                    selection.areaRestrictionType === 'bothArea'
                  )
                }
              }
              if (selection.areaRestrictionType === 'fromArea') {
                // お預かり先の場合
                return selection.availableDeliveryArea.includes(pickupAreaFlag)
              } else if (selection.areaRestrictionType === 'toArea') {
                // お届け先の場合
                return selection.availableDeliveryArea.includes(deliveryAreaFlag)
              } else {
                // 両方の場合
                return (
                  selection.availableDeliveryArea.includes(pickupAreaFlag) &&
                  selection.availableDeliveryArea.includes(deliveryAreaFlag)
                )
              }
            })

            // フィルタリング後の selections が存在する場合、新しいオブジェクトを返す
            if (filteredSelections.length > 0) {
              return {
                ...o,
                service: {
                  ...o.service,
                  selections: filteredSelections,
                },
              }
            } else {
              // selections が空の場合、null を返す
              return null
            }
          })
          // null の要素を取り除く
          .filter((o) => o !== null)
      )
    })

    const setOptionsOfService = (
      service: ModelKazaiOptionServices,
      selectedOptions: ModelKazaiOptionServicesOneSelection[],
    ) => {
      emit('selectOptions', {
        ...(props.selectedOptionsByServiceId || {}),
        [service.id]: selectedOptions,
      })
    }

    return {
      options,
      setOptionsOfService,
    }
  },
}
</script>
